import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // The class of the evaluation: a bilingual school runs one calendar per
  // language section, so the server only offers that class's periods.
  static values = { classroomId: String }

  load(event) {
    const trimesterId = event.target.value
    if (!trimesterId) return;

    const url = this.buildUrl(trimesterId)
    // The select widget fires « change » twice: only the latest answer counts.
    const token = (this.requestToken = (this.requestToken || 0) + 1)

    fetch(url, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    }).then((response) => {
      return response.text().then((streamHtml) => {
        if (token !== this.requestToken) return null;

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = streamHtml;
        const stream = Array.from(tempDiv.children).find((el) => el.tagName === "TURBO-STREAM")
        if (!stream) return null;

        this.keepCurrentPeriod(stream)
        document.body.appendChild(stream);
        return null;
      })
    })
  }

  // A period picked while the list was on its way is the user's choice:
  // the new list keeps it when the term still offers it.
  keepCurrentPeriod(stream) {
    const current = document.getElementById("evaluation_pedagogic_month_id")?.value
    const content = stream.querySelector("template")?.content
    if (!current || !content) return

    const option = content.querySelector(`option[value="${CSS.escape(current)}"]`)
    if (!option) return

    content.querySelectorAll("option[selected]").forEach((o) => o.removeAttribute("selected"))
    option.setAttribute("selected", "selected")
  }

  buildUrl(trimesterId) {
    // Detect namespace from current URL
    const currentPath = window.location.pathname
    const localeMatch = currentPath.match(/^\/([a-z]{2})\//)
    const locale = localeMatch ? localeMatch[1] : ''

    let basePath
    if (currentPath.includes('/teachers/')) {
      basePath = locale ? `/${locale}/teachers/evaluations` : '/teachers/evaluations'
    } else {
      basePath = locale ? `/${locale}/schools/books/evaluations` : '/schools/books/evaluations'
    }

    const params = new URLSearchParams({ trimester_id: trimesterId })
    if (this.hasClassroomIdValue && this.classroomIdValue) params.set("classroom_id", this.classroomIdValue)
    // The select widget fires « change » when it boots: without the current
    // period, the reloaded list dropped it (a form sent back with an error
    // lost its period). Kept only when the new term still offers it.
    const current = document.getElementById("evaluation_pedagogic_month_id")?.value
    if (current) params.set("selected_id", current)
    return `${basePath}/pedagogic_months_for_trimester?${params.toString()}`
  }
}
